import React, { useEffect, useState } from "react";
import * as S from "./styles.ts";
import Input from "../Inputs/Input/index.tsx";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationInstrumentadorSchema } from "../../schemas/validationSchema.ts";
import { InputMaskEnum } from "../../enums/InputMask.ts";
import { Typography } from "@mui/material";
import { Response } from "../../types/Api.ts";
import { Instrumentador } from "../../models/Instrumentador.ts";
import { Endereco } from "../../models/Endereco.ts";
import instrumentadorService from "../../services/instrumentadorService.ts";
import { useFeedback } from "../../contexts/FeedbackContext.tsx";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading/index.tsx";
import EnderecoComponent from "../Endereco/index.tsx";
import { InstrumentadorFormData } from "./type.ts";
import Switch from "@mui/material/Switch";
import { FormControlLabel } from "@mui/material";
import setupService from "../../services/setupService.ts";

const CadastroInstrumentador = ({ onAdd = (any) => {} }) => {
  const navigate = useNavigate();
  const { showFeedback } = useFeedback();
  const [isLoading, setIsLoading] = useState(false);
  const [notEmail, setNotEmail] = useState(false);
  const [podeNotificar, setPodeNotificar] = useState(false);
  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const features = await setupService.listFeatures();
        const funcionalidades = features.data.funcionalidade || {};
        setPodeNotificar(!!funcionalidades.notificarEmail);
      } catch (error) {
        console.error("Erro ao buscar funcionalidades do plano:", error);
      }
    };

    fetchFeatures();
  }, []);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationInstrumentadorSchema),
    defaultValues: {
      notificarEmail: false,
    },
  });

  const createInstrumentador = (data: any): Instrumentador => {
    const endereco: Endereco = new Endereco(
      data.endereco.rua,
      data.endereco.bairro,
      data.endereco.cep,
      data.endereco.numero,
      data.endereco.cidade,
      data.endereco.uf
    );
    return new Instrumentador(
      0,
      data.nome,
      data.cpf,
      data.email,
      data.telefone,
      data.notificarEmail,
      endereco
    );
  };

  const onSubmit = async (data: any) => {
    const instrumentador: Instrumentador = createInstrumentador(data);
    setIsLoading(true);
    try {
      const response: Response<Instrumentador> =
        await instrumentadorService.create(instrumentador);
      showFeedback(response.message, "success");
      if (onAdd) onAdd(response);
      else {
        navigate("/instrumentador/listagem");
      }
    } catch (error) {
      showFeedback(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setNotEmail(isChecked);
    setValue("notificarEmail", isChecked);
  };
  return (
    <S.Form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit)(e); }}>
      <S.InputGroup>
        <Input
          label="Nome do Instrumentador*"
          variant="outlined"
          register={register("nome")}
          error={errors.nome}
          helperText={errors.nome?.message}
        />
        <Input
          label="CPF*"
          variant="outlined"
          register={register("cpf")}
          error={errors.cpf}
          format={InputMaskEnum.CPF}
          helperText={errors.cpf?.message}
        />
        <Input
          label="Email"
          variant="outlined"
          register={register("email")}
          error={errors.email}
          helperText={errors.email?.message}
        />
        <Input
          label="Telefone*"
          variant="outlined"
          register={register("telefone")}
          error={errors.telefone}
          helperText={errors.telefone?.message}
          format={InputMaskEnum.BrazilPhone}
        />
      </S.InputGroup>
      <S.Notificacao>
        <FormControlLabel
          control={
            <Switch
              checked={notEmail}
              onChange={handleChange}
              disabled={!podeNotificar}
            />
          }
          label="Notificar Email"
          sx={{ color: "var(--ink)" }}
        />
      </S.Notificacao>
      {!podeNotificar && (
        <Typography
          variant="caption"
          color="error"
          style={{ marginLeft: "8px" }}
        >
          Disponível apenas para planos Premium.
        </Typography>
      )}

      <Typography variant="h6" gutterBottom sx={{ color: "var(--ink)" }}>
        Endereço
      </Typography>

      <EnderecoComponent<InstrumentadorFormData>
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        control={control}
      />

      <S.SubmitButton variant="contained" color="primary" type="submit">
        {isLoading ? <Loading color="white" /> : "Cadastrar"}
      </S.SubmitButton>
    </S.Form>
  );
};

export default CadastroInstrumentador;
